import { LOGIN_URL } from '@/app/constants';

const getLoginUrl = (returnTo?: string) => {
  if (!returnTo) {
    return LOGIN_URL;
  }
  return `${LOGIN_URL}?return_to=${encodeURIComponent(returnTo)}`;
};

export const getLoginUrlFromClient = () => {
  const returnTo = window?.location?.href;
  return getLoginUrl(returnTo);
};

export const getSignupUrlFromClient = () => {
  const loginUrl = getLoginUrlFromClient();
  const signupUrl = new URL(loginUrl);
  signupUrl.searchParams.set('login_mode', 'sign-up');
  return signupUrl.toString();
};
